import { API } from './interceptor'

export const notifyInvoiceUploadPaywallSales = ({
  venueId,
  source = 'client',
  platform = 'dashboard',
  currentUsage = null,
  remainingLimit = null,
  uploadCount = null,
  supplierTitle = null,
}) => {
  if (!venueId) {
    return Promise.resolve()
  }

  return API.post('api2', `venue/${venueId}/invoice-upload-paywall-notify`, {
    body: {
      source,
      platform,
      currentUsage,
      remainingLimit,
      uploadCount,
      supplierTitle,
    },
  }).catch(() => {
    // Fire-and-forget; paywall UX must not depend on sales notify
  })
}
